import { render, staticRenderFns } from "./_forme.vue?vue&type=template&id=499e4a58"
import script from "./_forme.js?vue&type=script&lang=js&external"
export * from "./_forme.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports